<template>
    <div>
        <div class="ini-summary__specific-content">
            <ini-badge v-if="ticketstatus.value != ''" name="ticketstatus" :value="ticketstatus.value" pill uppercase>
                {{ ticketstatus.displayValue }}
            </ini-badge>

            <ini-badge v-if="ticketcategories.value != ''" name="ticketcategories" :value="ticketcategories.value" pill small uppercase>
                {{ ticketcategories.displayValue }}
            </ini-badge>

            <span v-if="ticketpriorities.value != ''" class="ini-summary__ticketpriorities">
                <ticket-priority :value="ticketpriorities.value" :text="ticketpriorities.displayValue" with-text></ticket-priority>
            </span>
        </div>
        <div class="ini-summary__common-content">
            <ini-button v-if="showAddCommentButton" @click.native="focusOnElement('.ini-comment-control__input > textarea')" class="ini-summary__button ini-summary__button--add-comment" icon="plus">
                {{ $t('LBL_ADD_COMMENT') | uppercase }}
            </ini-button>
            <ini-button v-if="showResolvedButton" class="ini-summary__button ini-summary__button--resolved" icon="check"
                        @click="$emit('resolved-clicked')">{{ $t('LBL_RESOLVED') | uppercase }}</ini-button>
        </div>
    </div>
</template>

<script>
    import IniBadge from '@/components/HelpDesk/Badge'
    import StyleMixin from '@/mixins/StyleMixin.js'
    import TicketPriority from "@/components/HelpDesk/TicketPriority"
    import IniButton from '@/components/Button'
    import AppHelper from "@/helper";

    export default {
        mixins: [StyleMixin],

        props: {
            showAddCommentButton: {
                type: Boolean,
                default: true
            },
            showResolvedButton: {
                type: Boolean,
                default: true
            },
            ticket_title: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            ticket_num: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            ticketcategories: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            ticketstatus: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            ticketpriorities: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            createdtime: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            handledby: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
        },

        components: {
            IniBadge,
            TicketPriority,
            IniButton
        },
    
        methods: {
            focusOnElement: function(element){
                AppHelper.scrollAndFocusOnElement(element);
            }
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/HelpDesk/Detail/_summary.scss";</style>